import type { Status } from "../../types";

export type StatusButtonProps = {
  status: Status;
  variant: "primary" | "secondary";
  label: string;
  onClick: () => void;
};

const backgroundClasses = {
  upgrade: "bg-button-bg-status-upgrade-default",
  informative: "bg-button-bg-status-informative-default",
  warning: "bg-button-bg-status-warning-default",
  danger: "bg-button-bg-status-danger-default",
};

const StatusButton = (props: StatusButtonProps) => (
  <button
    onClick={() => props.onClick()}
    class="flex h-7.5 min-w-0 items-center justify-center rounded-sm border px-2.5 py-1.5 text-button-small focus-visible:outline-default"
    classList={{
      "border-button-border-status-upgrade text-button-text-status-upgrade hover:bg-button-bg-status-upgrade-hover active:bg-button-bg-status-upgrade-pressed":
        props.status === "upgrade",
      "border-button-border-status-informative text-button-text-status-informative hover:bg-button-bg-status-informative-hover active:bg-button-bg-status-informative-pressed":
        props.status === "informative",
      "border-button-border-status-warning text-button-text-status-warning hover:bg-button-bg-status-warning-hover active:bg-button-bg-status-warning-pressed":
        props.status === "warning",
      "border-button-border-status-danger text-button-text-status-danger hover:bg-button-bg-status-danger-hover active:bg-button-bg-status-danger-pressed":
        props.status === "danger",
      [backgroundClasses[props.status]]: props.variant === "primary",
    }}
  >
    <span class="truncate">{props.label}</span>
  </button>
);

export default StatusButton;
